<template>
  <div
    class="preview-tag-container"
    v-if="isShowPreview"
    @click.self="closePreview($event)"
  >
    <div class="preview-content" v-drag="'.preview-head'">
      <!-- <div
        class="preview-head"
        @mousedown.self="mouseDownWindow($event)"
        @mouseover.self="changeCursor($event, 1)"
        @mouseout.self="changeCursor($event, -1)"
      > -->
      <div class="preview-head">
        <span>预览</span>
        <div class="head-operate">
          <span
            v-if="itSize === 'normal'"
            @click="changeItSize($event, 'small')"
            ><Icon type="md-remove"
          /></span>
          <span
            v-if="itSize === 'big' || itSize === 'small'"
            @click="changeItSize($event, 'normal')"
            ><Icon type="md-qr-scanner"
          /></span>
          <span v-else @click="changeItSize($event, 'big')"
            ><Icon type="md-resize"
          /></span>
          <span @click="closePreview($event)"><Icon type="md-close"/></span>
        </div>
      </div>
      <div class="preview-box">
        <ModelShow ref="modelShowRef"/>
        <span @mousedown.self="resizeBox($event)"></span>
      </div>
    </div>
  </div>
</template>

<script>
import drag from "@/directive/drag-dialog";
import { config } from "@/components/modeldemo/config";
import ModelShow from "@/components/modeldemo/ModelShow";
export default {
  name: "ModelPreview",
  components: { ModelShow },
  props: {
    isShowPreview: {
      type: Boolean,
      default: false
    },
    modelId: {
      type: String
    }
  },
  model: {
    prop: "isShowPreview",
    event: "changeShow"
  },
  data() {
    return {
      itSize: "normal"
    };
  },
  watch: {
    isShowPreview: function(val) {
      if(!val) return
      let setting = null;
      const render = this.$nextTick();
      const modelPlusHttp = this.$http(
        `/api/model/modelPlus/id/${this.modelId}`
      )
        .then(res => {
          if (res.data.status === 200) {
            setting = res.data.data;
          } else {
            console.warn("模型数据获取失败");
          }
        })
        .catch(() => {
          console.warn("模型数据获取异常");
        });
      Promise.all([modelPlusHttp, render]).then(() => {
        this.$refs.modelShowRef.init(setting);
      });
    }
  },
  methods: {
    closePreview() {
      // 视图大小恢复成默认
      this.itSize = 'normal'
      this.$emit("changeShow", false);
    },
    changeItSize(e, size) {
      this.itSize = size;

      const previewContent =
        e.currentTarget.parentElement.parentElement.parentElement;
      if (size === "small") {
        previewContent.style.width = "200px";
        previewContent.style.height = "44px";

        previewContent.style.left = "0";
        previewContent.style.top = "calc(100% - 68px)";
      } else if (size === "big") {
        previewContent.style.width = "100%";
        previewContent.style.height = "100%";

        previewContent.style.left = "0";
        previewContent.style.top = "0";
      } else {
        previewContent.style.width = "900px";
        previewContent.style.height = "600px";

        previewContent.style.left = "calc(50% - 450px)";
        previewContent.style.top = "calc(50% - 300px)";
      }
      this.$refs.modelShowRef && this.$refs.modelShowRef.resizeContent()
    },
    resizeBox(e) {
      let [divX, divY] = [e.clientX, e.clientY];
      const parentObj =
        e.currentTarget.parentElement.parentElement.parentElement;
      const previewContent = e.currentTarget.parentElement.parentElement;

      // 鼠标移动事件
      parentObj.onmousemove = ev => {
        const oevent = ev || event;

        const [moveX, moveY] = [oevent.clientX, oevent.clientY];
        if (
          moveX >= document.body.clientWidth ||
          moveY >= document.body.clientHeight
        )
          return;

        const X = moveX - divX;
        const Y = moveY - divY;

        [divX, divY] = [moveX, moveY];

        previewContent.style.width =
          previewContent.getBoundingClientRect().width + X + "px";
        previewContent.style.height =
          previewContent.getBoundingClientRect().height + Y + "px";
      };

      // 取消绑定
      document.onmouseup = () => {
        parentObj.onmousemove = null;
        document.onmouseup = null;
      };
    }
  },
  directives: {
    drag
  }
};
</script>

<style scoped lang="less">
.preview-tag-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 9999999;

  .preview-content {
    position: absolute;
    top: calc(50% - 300px);
    left: calc(50% - 450px);
    width: 900px;
    height: 600px;

    .preview-head {
      width: 100%;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;
      font-size: 14px;
      padding: 0 20px;
      color: #333;
      overflow: hidden;
      background-color: #f8f8f8;
      border-radius: 2px 2px 0 0;
      -webkit-border-radius: 2px 2px 0 0;
      -moz-border-radius: 2px 2px 0 0;
      -ms-border-radius: 2px 2px 0 0;
      -o-border-radius: 2px 2px 0 0;
      user-select: none;
      -moz-user-select: none;
      -webkit-user-select: none;

      .head-operate {
        width: 80px;
        display: flex;
        align-items: center;
        font-size: 16px;
        justify-content: space-evenly;

        span {
          width: 40px;
          height: 40px;
          display: flex;
          justify-content: center;
          align-items: center;

          &:hover {
            cursor: pointer;
            color: #2783f2;
          }
        }
      }
    }

    .preview-box {
      position: relative;
      width: 100%;
      height: calc(100% - 44px);
      background-color: #aaa;
      span {
        position: absolute;
        width: 15px;
        height: 15px;
        right: 0;
        bottom: 0;
        cursor: se-resize;
      }
    }
  }
}
</style>
